import * as am5map from '@amcharts/amcharts5/map';
import worldLow from '@amcharts/amcharts5-geodata/worldLow';
import * as am5 from '@amcharts/amcharts5';

import { applyClickView } from './applyClickView';


export const applyHeat = (
    root: any,
    mainChart: any,
    data: any,
    filter: any,
    setPolygonSeriesHeatMap: any,
    selectedCountryPolygon: any,
    handleSelectCountry: any,
    handleHoveredCountry: any,
) => {

    // Create polygon series
    const polygonSeriesHeatMap = mainChart.series.push(
        am5map.MapPolygonSeries.new(root, {
            geoJSON: worldLow,
            valueField: filter,
            calculateAggregates: true,
        }),
    );

    applyClickView(
        polygonSeriesHeatMap,
        mainChart,
        selectedCountryPolygon,
        handleSelectCountry,
    );

    polygonSeriesHeatMap.mapPolygons.template.events.on(
        'pointerover',
        (event: any) => {
            handleHoveredCountry(event.target.dataItem.dataContext.code);
        },
    );

    polygonSeriesHeatMap.mapPolygons.template.states.create('active', {
        fill: am5.color(0x92a7d6),
    });

    let colors = {
        min: am5.color(0x8795a8),
        max: am5.color(0x003b5c),
    };
    if (filter === 'glriRank') {
        colors = {
            min: am5.color(0x003b5c),
            max: am5.color(0x8795a8),
        }
    }
    if (filter === 'greenRank') {
        colors = {
            min: am5.color(0x38761D),
            max: am5.color(0xB6D7A8),
        }
    }
    /*if (filter === 'country') {
        colors = {
            min: am5.color(0xa2aee2),
            max: am5.color(0x3a58f0),
        };
    }*/

    polygonSeriesHeatMap.set('heatRules', [
        {
            target: polygonSeriesHeatMap.mapPolygons.template,
            dataField: 'value',
            key: 'fill',
            ...colors,
        },
    ]);

    polygonSeriesHeatMap.mapPolygons.template.setAll({
        tooltipText: `[font-size: 1rem;]{name}[/]: [font-size: 1rem;]{value}[/]`,
        fill: filter === 'greenRank' ? am5.color(0xCCCCCC) : am5.color(0xbdd6e4),
        stroke: am5.color(0x2e8bc0),
        strokeWidth: 2,
        fillOpacity: 1,
        strokeOpacity: 1,
        toggleKey: 'active',
        interactive: true,
    });

    polygonSeriesHeatMap.data.setAll(data);

    setPolygonSeriesHeatMap(polygonSeriesHeatMap);
};

export const removeHeat = (mainChart: any, polygonSeriesHeatMap: any) => {
    if (
        polygonSeriesHeatMap &&
        mainChart.series.indexOf(polygonSeriesHeatMap) > 0
    ) {
        mainChart.series.removeIndex(
            mainChart.series.indexOf(polygonSeriesHeatMap),
        );
    }
};
